<template>

    <router-view/>

</template>

<script>
export default {
  mounted() {
    this.topNoPullDown();
  },
  methods: {
    topNoPullDown() {
      const overscroll = function (el) {
        el.addEventListener('touchstart', function () {
          const top = el.scrollTop;
          const totalScroll = el.scrollHeight;
          const currentScroll = top + el.offsetHeight;
          el.scrollTop = top - 1;
          el.addEventListener('touchmove', function (evt) {
            if (el.offsetHeight < el.scrollHeight) evt._isScroller = true;
          });
        });
      };
      overscroll(document.querySelector('#app'));
    }
  }
};
</script>

